import { combineReducers } from 'redux';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { reducer as formReducer } from 'redux-form';
import { reducer as auth } from 'store/modules/auth';
import { reducer as modal } from 'store/modules/modal';
import { reducer as home } from 'routes/Dashboard/Home';
import { reducer as cms } from 'routes/Dashboard/Cms';
import { reducer as mam } from 'routes/Dashboard/Mam';
import { reducer as mam2 } from 'routes/Dashboard/Mam2';
import { reducer as data } from 'routes/Dashboard/Data';
import { reducer as analytics } from 'routes/Dashboard/Analytics';
import { reducer as imageLibrary } from 'routes/Dashboard/ImageLibrary';
//import { reducer as channel } from 'routes/Dashboard/Channel';
import { reducer as channelAdmin } from 'routes/Dashboard/Channel/admin';
import { reducer as channelHost } from 'routes/Dashboard/Channel/host';
import { reducer as passinfo } from 'routes/Dashboard/PassKitInfo';

export const rootReducer = combineReducers({
  loadingBar: loadingBarReducer,
  auth,
  modal,
  form: formReducer,

  // Dashboard
  home,
  cms,
  mam,
  mam2,
  data,
  analytics,
  imageLibrary,
  // channel,
  channelAdmin,
  channelHost,
  passinfo,
});

export default rootReducer;
